import { FC } from 'react';
import { IconProps } from './SatIcon';

const ReportIcon: FC<IconProps> = ({ id, fill, className }) => {
  return (
    <svg
      id={id}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 31 30"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.747559 28H30.7476V30H0.747559V28Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M5.24756 11C4.84973 11 4.4682 11.158 4.1869 11.4393C3.90559 11.7206 3.74756 12.1022 3.74756 12.5V26H9.74756V12.5C9.74756 12.1022 9.58952 11.7206 9.30822 11.4393C9.02691 11.158 8.64538 11 8.24756 11H5.24756Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M14.2476 19C13.8497 19 13.4682 19.158 13.1869 19.4393C12.9056 19.7206 12.7476 20.1022 12.7476 20.5V26H18.7476V20.5C18.7476 20.1022 18.5895 19.7206 18.3082 19.4393C18.0269 19.158 17.6454 19 17.2476 19H14.2476Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M23.2476 22C22.8497 22 22.4682 22.158 22.1869 22.4393C21.9056 22.7206 21.7476 23.1022 21.7476 23.5V26H27.7476V23.5C27.7476 23.1022 27.5895 22.7206 27.3082 22.4393C27.0269 22.158 26.6454 22 26.2476 22H23.2476Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M13.0478 13.08C13.3801 14.1861 13.9845 15.1913 14.8055 16.0036C15.6266 16.8159 16.6382 17.4095 17.7478 17.73C18.3992 17.9099 19.072 18.0008 19.7478 18C21.6043 18 23.3848 17.2625 24.6975 15.9498C26.0103 14.637 26.7478 12.8565 26.7478 11C26.7478 10.7348 26.6424 10.4804 26.4549 10.2929C26.2673 10.1054 26.013 10 25.7478 10H22.2478C21.8499 10 21.4684 9.84198 21.1871 9.56067C20.9058 9.27937 20.7478 8.89784 20.7478 8.50001V5.00001C20.7478 4.7348 20.6424 4.48044 20.4549 4.29291C20.2673 4.10537 20.013 4.00001 19.7478 4.00001C18.7037 3.99795 17.6724 4.22947 16.7294 4.67762C15.7864 5.12577 14.9555 5.77918 14.2978 6.59001C13.5772 7.48853 13.0868 8.54926 12.869 9.6802C12.6512 10.8111 12.7125 11.9782 13.0478 13.08Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M23.7476 8H29.7476C30.0128 8 30.2671 7.89464 30.4547 7.70711C30.6422 7.51957 30.7476 7.26522 30.7476 7C30.7476 5.14348 30.0101 3.36301 28.6973 2.05025C27.3846 0.737498 25.6041 0 23.7476 0C23.4823 0 23.228 0.105357 23.0405 0.292893C22.8529 0.48043 22.7476 0.734784 22.7476 1V6.51C22.7476 7.55 23.1976 8 23.7476 8Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M0.747559 0H14.7476V2H0.747559V0Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M0.747559 4H9.74756V6H0.747559V4Z"
        fill={fill || '#89AAEC'}
      />
    </svg>
  );
};

export default ReportIcon;
